import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ClinicalForm } from './ModuleFE_ClinicalForm.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_ClinicalForm,
    modules: [ModuleFE_ClinicalForm],
    mapper: item => [item.title],
    placeholder: 'Choose a Clinical Form',
    renderer: item => _jsx(_Fragment, { children: item.title })
};
export const DropDown_ClinicalForm = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_ClinicalForm,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.title] });
    },
    uiSelector: DropDown_ClinicalForm.selectable,
});
export const MultiSelect_ClinicalForm = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map